
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetojyotiba() {



    const cardData =
    {
        keyword: 'Pune to Jyotiba Cab',
        heading: 'Meghana Cab : Pune to Jyotiba Cab ',
        headingDescription: 'Meghana Cab offers Pune to Jyotiba Cab services, ensuring a smooth and comfortable journey to the sacred Jyotiba Temple near Kolhapur. Ideal for devotees and family travelers, our reliable cab service covers approximately 230 kilometers with complete safety and convenience. Travel through scenic highways in our clean, air-conditioned sedans, SUVs, or tempo travellers driven by experienced chauffeurs who know the temple routes well. Whether you’re planning a day trip or a round-trip pilgrimage, enjoy on-time pickups, transparent fares, and 24×7 customer support. Book your Pune to Jyotiba Cab with Meghana Cab for a peaceful, affordable, and spiritually fulfilling travel experience.',


        top: 'Top Places to Visit in Jyotiba with Meghana Cab',

"topPlaces": [
  {
    "title": "Jyotiba Temple (Jyotirlinga of Kolhapur Hills)",
    "description": "The sacred Jyotiba Temple, perched 3,000 feet above sea level in the Wadi Ratnagiri hills near Kolhapur, is one of Maharashtra’s most powerful pilgrimage sites. Dedicated to Lord Jyotiba, believed to be an incarnation of Lord Shiva, it draws thousands of devotees throughout the year. The temple’s deep pink walls and stone architecture stand out against the green Sahyadri backdrop. Every Sunday, devotees throng here with pink gulal (holy powder) — a symbol of victory and devotion. During the annual Chaitra Yatra, the entire hill turns pink as lakhs of pilgrims gather in faith, chanting “Jyotiba cha Dongar,” creating a truly divine atmosphere."
  },
  {
    "title": "Jyotiba Hill (Wadi Ratnagiri)",
    "description": "Jyotiba Hill, also known as Wadi Ratnagiri, is a spiritually charged mountain range that offers panoramic views of the Kolhapur region. The winding road to the top is scenic, lined with dense forests, small waterfalls, and roadside vendors selling coconuts and flowers for offerings. The air here is thick with devotion and the scent of incense. Pilgrims often climb the final steps barefoot, singing bhajans in praise of Lord Jyotiba. The cool mountain breeze, temple bells, and chants create an aura of divine serenity. At sunset, the sky above the pink-tinted hill glows with a mystical charm that feels timeless."
  },
  {
    "title": "Chaitra Yatra Festival",
    "description": "The grand Chaitra Yatra, celebrated in March–April, is one of Maharashtra’s largest religious gatherings dedicated to Lord Jyotiba. Pilgrims from across the state walk barefoot to the temple, carrying palkhis (palanquins) and chanting hymns. The entire hill turns pink with gulal as devotees shower it during rituals, creating a surreal sight visible from miles away. The festival includes traditional dhol-tasha performances, devotional songs, and night-long prayers. It symbolizes unity, devotion, and the victory of good over evil. Experiencing the Chaitra Yatra offers a deep spiritual connection to the cultural heartbeat of Maharashtra."
  },
  {
    "title": "Shree Yamai Mandir (at the base of Jyotiba Hill)",
    "description": "At the foothills of Jyotiba lies the Shree Yamai Mandir, dedicated to Goddess Yamai, who is considered a guardian deity of the region. Devotees visit her shrine before climbing up to Jyotiba Temple. The temple’s architecture is simple yet powerful, adorned with ancient stone carvings and traditional toranas. During festivals, the temple is decorated with lamps and marigold garlands, and the air fills with bhakti songs. Local vendors sell garlands, sweets, and gulal for offerings. The site is peaceful, offering a glimpse into the humble and devout side of Maharashtra’s rural spirituality."
  },
  {
    "title": "Panhala Fort (Nearby)",
    "description": "Just 18 km from Jyotiba lies Panhala Fort, one of the largest and most historically significant forts in Maharashtra. It was once the stronghold of Chhatrapati Shivaji Maharaj and later Sambhaji Maharaj. The fort’s massive ramparts, watchtowers, and the iconic Teen Darwaza narrate tales of Maratha valor. The view from the top stretches across green valleys and distant hills. During monsoon, mist and clouds envelop the fort, creating a mystical experience. For pilgrims visiting Jyotiba, Panhala adds a dose of history and adventure to their spiritual journey."
  },
  {
    "title": "Mahalaxmi Temple, Kolhapur",
    "description": "Located about 20 km from Jyotiba, the Mahalaxmi Temple in Kolhapur is one of India’s Shakti Peethas and a must-visit for every devotee. Dedicated to Goddess Ambabai (Mahalaxmi), the temple’s black stone structure and intricate carvings date back to the 7th century. The daily rituals, aarti, and festive celebrations fill the complex with divine energy. Devotees often visit both Mahalaxmi and Jyotiba temples on the same day, as it is believed that visiting them together fulfills one’s wishes. The temple complex also includes small shrines, souvenir shops, and Prasad counters offering authentic Kolhapuri sweets."
  },
  {
    "title": "Gagangiri Maharaj Math (Gaganbawda)",
    "description": "Situated amidst the misty Gaganbawda hills near Jyotiba, the Gagangiri Maharaj Math is a spiritual retreat founded by the revered saint Gagangiri Maharaj. Surrounded by dense forests and waterfalls, this math exudes peace and natural beauty. Devotees and travelers come here to meditate, learn yoga, and seek blessings. The serene environment, chanting of mantras, and the fragrance of sandalwood create a perfect escape from worldly chaos. The Math also serves as an eco-friendly ashram promoting simplicity, discipline, and spiritual awakening — complementing the divine aura of Jyotiba."
  },
  {
    "title": "Rautwadi Waterfall",
    "description": "Hidden in the forests near Jyotiba Hill, Rautwadi Waterfall is a picturesque natural retreat perfect for nature lovers and trekkers. The waterfall cascades gracefully from a height surrounded by moss-covered rocks and dense vegetation. During monsoon, the area turns into a lush paradise with flowing streams and chirping birds. Local guides help visitors navigate the trail safely. The tranquil ambiance and refreshing waters make it an ideal picnic spot. Many devotees visit Rautwadi after darshan at Jyotiba Temple to relax and soak in nature’s calm beauty."
  },
  {
    "title": "Rankala Lake, Kolhapur",
    "description": "Rankala Lake, located about 25 km from Jyotiba, is a scenic man-made lake built by Chhatrapati Shahu Maharaj. It’s a popular hangout spot for locals and tourists, surrounded by gardens, temples, and street food stalls. The lake is especially beautiful at sunset when the water reflects golden hues of the sky. Visitors can enjoy boating, horse rides, or a walk along the promenade. The lakefront also offers local snacks like bhel, ice gola, and pav bhaji, adding a flavorful touch to your Kolhapur–Jyotiba trip."
  },
  {
    "title": "Kolhapuri Cuisine and Local Markets",
    "description": "A visit to Jyotiba is incomplete without indulging in Kolhapur’s legendary cuisine. Local eateries near the temple and in Kolhapur serve spicy Kolhapuri misal, tambda rassa, pandhra rassa, and authentic thalis. For dessert, try puran poli or dudh poli. The local markets overflow with handcrafted chappals, jewelry, and jaggery sweets. Devotees often buy pink gulal and coconuts as souvenirs from Jyotiba Hill. This culinary and shopping experience, combined with spiritual sightseeing, completes the journey with flavor, devotion, and culture in perfect harmony."
  }
],

        "services": [
    {
      "name": "Pune to Kolhapur Cab Service",
      "description": "Meghana Cab offers reliable Pune to Kolhapur cab service for business, temple visits, and family travel. Our well-maintained vehicles and professional drivers ensure a safe and pleasant journey through the scenic Pune–Satara–Kolhapur route. Enjoy door-to-door pickup, comfortable seating, and flexible one-way or round-trip options. Perfect for visiting Mahalaxmi Temple, Jyotiba Hill, or local attractions in Kolhapur."
    },
    {
      "name": "Pune to Kolhapur Cab Booking",
      "description": "Easily book a cab from Pune to Kolhapur online with Meghana Cab. Choose from sedans, SUVs, Ertiga, or Innova Crysta for your comfortable travel experience. Our service offers affordable fares, punctual pickups, and courteous drivers familiar with all major stops like Mahalaxmi Temple and Jyotiba Temple. Book one-way or round-trip cabs based on your travel plans."
    },
    {
      "name": "Pune to Balumama Cab Service",
      "description": "Plan your spiritual journey to Balumama Temple near Kolhapur with Meghana Cab. We offer dedicated Pune to Balumama cab services for pilgrims and families, featuring clean cars, AC comfort, and flexible pickup locations. Our drivers are well-acquainted with temple routes, ensuring a smooth and timely trip for darshan and return travel."
    },
    {
      "name": "Pune to Admapur Cab",
      "description": "Book a cab from Pune to Admapur with Meghana Cab for a safe and comfortable temple visit. Whether traveling solo or with family, our cars provide spacious seating and reliable service at affordable prices. Enjoy professional drivers, well-maintained vehicles, and hassle-free booking for your Admapur pilgrimage."
    },
    {
      "name": "Pune to Kolhapur Laxmi Temple Cab",
      "description": "Visit the famous Mahalaxmi Temple in Kolhapur comfortably with Meghana Cab’s dedicated cab service. Our Pune to Kolhapur Mahalaxmi Temple cab offers convenient door-to-door travel, flexible schedules, and clean, air-conditioned cars. Perfect for devotees and families planning a peaceful temple visit."
    },
    {
      "name": "Pune to Jyotiba Cab Package",
      "description": "Meghana Cab provides exclusive Pune to Jyotiba cab packages, ideal for devotees visiting the sacred Jyotiba Temple near Kolhapur. Our packages include comfortable round trips, experienced drivers, and customizable options to add nearby temple visits like Mahalaxmi and Gagangiri Ashram. Choose from sedans, SUVs, or luxury Innova cabs."
    },
    {
      "name": "Pune to Jyotiba Innova Cab Package",
      "description": "Travel in comfort with our Pune to Jyotiba Innova cab package. The spacious and air-conditioned Innova ensures a relaxed journey for families and groups. Meghana Cab offers round-trip and one-way packages at affordable rates, perfect for temple visits and local sightseeing around Kolhapur."
    },
    {
      "name": "Pune to Jyotiba Innova Crysta Cab",
      "description": "Book an Innova Crysta from Pune to Jyotiba Temple for a premium travel experience. With plush interiors, extra legroom, and smooth performance, the Crysta ensures luxurious comfort for devotees and families. Meghana Cab guarantees punctual pickups, clean vehicles, and professional drivers for your temple visit."
    },
    {
      "name": "Pune to Jyotiba Ertiga Cab",
      "description": "Opt for a comfortable Ertiga cab from Pune to Jyotiba with Meghana Cab. Ideal for small groups and families, our Ertiga cabs are spacious, fuel-efficient, and well-maintained. We ensure safe and timely travel for your Kolhapur temple darshan, with flexible return options to Pune."
    },
    {
      "name": "Pune to Jyotiba Sedan Cab Booking",
      "description": "Book a sedan cab from Pune to Jyotiba Temple with Meghana Cab for an economical and smooth travel experience. Perfect for solo travelers or small families, our sedans offer a comfortable ride through the scenic Western Ghats, ensuring a peaceful temple trip."
    },
    {
      "name": "Pimpri Chinchwad to Jyotiba Temple Cab",
      "description": "Meghana Cab provides reliable cab service from Pimpri Chinchwad to Jyotiba Temple near Kolhapur. Whether for religious visits or weekend trips, enjoy safe and comfortable travel in well-maintained cars with experienced drivers familiar with the temple routes."
    },
    {
      "name": "Pune to Kolhapur Gagangiri Cab",
      "description": "Plan a spiritual journey from Pune to Gagangiri Maharaj Math in Kolhapur with Meghana Cab. Our cab service ensures comfortable and convenient travel with professional drivers who know all major temple routes. Choose from a range of vehicles for your spiritual retreat."
    },
    {
      "name": "Pune to Jyotiba Kia Carens Cab",
      "description": "Experience premium comfort with our Pune to Jyotiba Kia Carens cab service. Ideal for families seeking extra luxury, this cab comes with superior interiors, AC comfort, and ample legroom. Perfect for long-distance temple trips or family getaways to Kolhapur."
    },
    {
      "name": "Pune to Jyotiba Temple Kolhapur Cab",
      "description": "Visit the sacred Jyotiba Temple near Kolhapur with Meghana Cab’s reliable Pune to Jyotiba cab service. Our well-maintained vehicles and professional drivers ensure a comfortable journey for devotees. Choose one-way, round-trip, or package options with stops at nearby temples like Mahalaxmi and Gagangiri Math."
    }
  ],
  "tableData": [
    ["Pune to Kolhapur Cab Service", "Pune to Kolhapur Cab Booking"],
    ["Pune to Balumama Cab Service", "Pune to Admapur Cab"],
    ["Pune to Kolhapur Laxmi Temple Cab", "Pune to Jyotiba Cab Package"],
    ["Pune to Jyotiba Innova Cab Package", "Pune to Jyotiba Innova Crysta Cab"],
    ["Pune to Jyotiba Ertiga Cab", "Pune to Jyotiba Sedan Cab Booking"],
    ["Pimpri Chinchwad to Jyotiba Temple Cab", "Pune to Kolhapur Gagangiri Cab"],
    ["Pune to Jyotiba Kia Carens Cab", "Pune to Jyotiba Temple Kolhapur Cab"]
  ],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Jyotiba Cab Service",
        "WhyChoosedescription": "Meghana Cab offers dependable cab services from Pune to the revered Jyotiba temple near Kolhapur, ensuring a smooth and spiritually fulfilling journey."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop at Jyotiba Temple",
        "WhyChoosedescription": "Enjoy punctual pick-up from Pune and on-time drop at Jyotiba temple, allowing you to attend rituals and darshan without any travel-related stress."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Temple Routes",
        "WhyChoosedescription": "Our trained drivers are familiar with the Pune to Jyotiba route and local temple timings, ensuring a safe and well-timed trip for devotees."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Cab Fare",
        "WhyChoosedescription": "We provide budget-friendly cab fares with no hidden charges. Get full value for your money with our clear and upfront pricing structure."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "Travel in sanitized and well-maintained cabs, equipped with GPS, seat belts, and other essential safety features for a secure pilgrimage."
    },
    {
        "WhyChooseheading": "24/7 Availability for Jyotiba Temple Visits",
        "WhyChoosedescription": "Whether you plan a daytime darshan or a night journey, Meghana Cab is available round the clock for your Pune to Jyotiba temple travel needs."
    },
    {
        "WhyChooseheading": "Customizable Travel Options",
        "WhyChoosedescription": "Choose from one-way, round-trip, or personalized travel packages to include additional stops such as Kolhapur Mahalaxmi Temple or Panhala Fort."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Devotee Support",
        "WhyChoosedescription": "Book your cab easily through our website or app. Our dedicated support team is always ready to assist you with bookings and special pilgrimage requests."
    }
]

























    }




const faqData = [
    {
        question: "How can I book a Pune to Jyotiba cab with Meghana Cab?",
        answer: "You can book a Pune to Jyotiba cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What cab options are available for travel from Pune to Jyotiba?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for Pune to Jyotiba trips, depending on your group size and comfort preference."
    },
    {
        question: "Is one-way cab service available from Pune to Jyotiba?",
        answer: "Yes, we offer both one-way and round-trip cab services from Pune to Jyotiba."
    },
    {
        question: "How long does it take to travel from Pune to Jyotiba by cab?",
        answer: "The journey typically takes around 3 to 4 hours, depending on traffic and route conditions."
    },
    {
        question: "Are tolls and taxes included in the cab fare for Pune to Jyotiba?",
        answer: "Tolls, state taxes, and parking charges are additional and clearly communicated during the booking process."
    },
    {
        question: "Are Meghana Cab drivers experienced for pilgrimage and hill route travel like Pune to Jyotiba?",
        answer: "Yes, our drivers are professional, experienced, and familiar with routes to Jyotiba and similar pilgrimage destinations."
    },
    {
        question: "Can I request breaks or custom stops during the Pune to Jyotiba journey?",
        answer: "Yes, you can request halts or breaks during the trip. Please inform us while booking."
    },
    {
        question: "Is the cab service from Pune to Jyotiba available at night?",
        answer: "Yes, Meghana Cab provides 24/7 service, so you can schedule a day or night departure as per your convenience."
    },
    {
        question: "What payment options are accepted for Pune to Jyotiba cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for all bookings."
    },
    {
        question: "How do I contact Meghana Cab to book a Pune to Jyotiba cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rohan Kadam',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I booked a cab from Pune to Jyotiba with Meghana Cab. The ride was smooth, driver courteous and the timings perfect. Felt very safe throughout.”',
    },
    {
        name: 'Mrs. Snehal Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Beautiful trip to Jyotiba. Meghana Cab made the journey comfortable; the vehicle was clean and driver very helpful.”',
    },
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jyotiba Cab",
  "description": "Travel from Pune to Jyotiba with Meghana Cabs offering reliable cab services including Innova, Crysta, Ertiga, and sedan bookings. Perfect for temple visits, Kolhapur trips, and comfortable journeys at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2890"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Jyotiba Cab | Reliable Temple Taxi Service @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to Jyotiba cab with Meghana Cabs for comfortable temple visits and Kolhapur trips. Affordable cab packages with Innova, Crysta, Ertiga, and sedan options. Book your reliable cab today."
  />
  <meta
    name="keywords"
    content="pune to kolhapur cab service, pune to kolhapur cab booking, pune to balumama cab service, Pune to Admapur Cab, pune to kolhapur laxmi temple cab, pune to jyotiba cab package, pune to jyotiba innova cab package, pune to jyotiba innova crysta cab, pune to jyotiba ertiga cab, pune to jyotiba sedan cab booking, pimpri chinchwad to jyotiba temple cab, pimpri chinchwad to jyotiba cab, pune to kolhapur gagangiri cab, pune to jyotiba kia carens cab, pimpri chinchwad to jyotiba temple cab , pune to jyotiba temple kolhapur cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>





            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/66.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetojyotiba;